import { PageWrapper } from "@/components/Common/PageWrapper/PageWrapper";
import { createClusterData, newInitialFormValues } from "@/store/simpleCluster";
import { ClusterType, SimpleClusterForm } from "@/types";
import { Formik } from "formik";
import { CreateContainerFormV2 } from "@/components/ClustersPage/CreateContainerFormV2/CreateContainerFormV2";
import { useEffect, useMemo } from "react";

const CreateContainerPage = () => {
  const initialValues = useMemo<SimpleClusterForm>(
    () => ({
      ...newInitialFormValues,
      containerImage: "",
      replicaCount: "1",
      trafficPort: 8000,
      // Empty until a known recipe applies its path (or the user sets one for custom).
      healthCheckPath: "",
      healthCheckIntervalSeconds: 10,
      healthCheckTimeoutSeconds: 10,
      healthCheckGracePeriodSeconds: 60,
      username: undefined,
      locations: [],
      secret: undefined,
      createClusterData,
      durationType: "hourly",
      durationQuantity: 1,
      clusterType: ClusterType.CONTAINER,
      currency: "credits"
    }),
    []
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1024px)");
    const originalOverflowY = document.body.style.overflowY;
    const originalOverscrollBehaviorY = document.body.style.overscrollBehaviorY;

    const syncBodyScroll = () => {
      if (mediaQuery.matches) {
        document.body.style.overflowY = "hidden";
        document.body.style.overscrollBehaviorY = "none";
        return;
      }

      document.body.style.overflowY = originalOverflowY;
      document.body.style.overscrollBehaviorY = originalOverscrollBehaviorY;
    };

    syncBodyScroll();
    mediaQuery.addEventListener("change", syncBodyScroll);

    return () => {
      mediaQuery.removeEventListener("change", syncBodyScroll);
      document.body.style.overflowY = originalOverflowY;
      document.body.style.overscrollBehaviorY = originalOverscrollBehaviorY;
    };
  }, []);

  return (
    <PageWrapper>
      <Formik<SimpleClusterForm>
        initialValues={initialValues}
        onSubmit={(values) => console.log(values)}
        validateOnMount={true}
        enableReinitialize={true}
      >
        <CreateContainerFormV2 formData={createClusterData} />
      </Formik>
    </PageWrapper>
  );
};

export default CreateContainerPage;
